import { render, staticRenderFns } from "./FlightPaxes.vue?vue&type=template&id=645bb19e&scoped=true"
import script from "./FlightPaxes.vue?vue&type=script&lang=js"
export * from "./FlightPaxes.vue?vue&type=script&lang=js"
import style0 from "./FlightPaxes.vue?vue&type=style&index=0&id=645bb19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645bb19e",
  null
  
)

export default component.exports